import * as React from 'react';
import GatsbyImage from 'gatsby-image';

import { useGraphQL } from '../hooks';
import { GLFOnlinePortrait } from './vectors';

function Hero() {
  const {
    site: {
      siteMetadata: { title },
    },
    heroImage,
  } = useGraphQL();

  return (
    <article className="relative bg-white">
      <div className="flex flex-col-reverse w-full mx-auto md:flex-row max-w-7xl">
        <div className="px-4 pt-6 pb-12 bg-white sm:px-6 lg:px-8">
          <div className="px-4 md:w-64 mt-9">
            <GLFOnlinePortrait className="hidden w-full max-w-xs mx-auto text-black md:block" />
            <h1 className="mt-12 h2">
              Top brand <br />
              golf apparel <br />
              and accessories for women <br />
              and men
            </h1>
            <div aria-hidden className="flex w-10/12 h-3 mt-6 overflow-hidden">
              <div className="w-1/2 bg-brand-pink">
                <div className="h-full transform -skew-x-12 bg-brand-pink" />
              </div>
              <div className="w-1/2 bg-brand-blue">
                <div className="h-full transform -skew-x-12 bg-brand-blue" />
              </div>
            </div>
            <p className="mt-6 text-gray-700">
              {title} is the online specialist in golf apparel, clothing,
              accessories, and everything golfing for men's and women's needs.
              Head onto our website to get all your golfing needs.
            </p>
          </div>
        </div>
        <div aria-hidden className="flex flex-col flex-1">
          <GatsbyImage
            fluid={heroImage.childImageSharp.fluid}
            className="flex-1 h-full"
          />
        </div>
      </div>
    </article>
  );
}

export { Hero };
